<template>
    <div class="apple_group">
        <div class="create_list">
            <div class="create_title">所属系列组</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">所属广告系列组：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['org_id'] != '' ? true : false}">
                    <el-select
                    v-model="form.org_id" 
                    placeholder="输入广告系列组ID或名称关键字搜索" 
                    class="width400"
                    filterable
                    :loading="searchOrgLoading"
                    @visible-change="handleOrgFocus"
                    @change="handleOrgSelect"
                    ref="org_id"
                    size="mini"
                    :disabled="apple_create_type == 'editGroup' ? true : false"
                    >
                        <el-option
                            v-for="item in filterOrgOptions"
                            :key="item.value"
                            :label="item.label+'【'+item.value+'】'"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['org_id']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">所属广告系列</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">所属广告系列：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['campaign_id'] != '' ? true : false}">
                    <el-tooltip placement="top" :disabled="form.org_id == '' ? false : true" :open-delay="500">
                        <div slot="content">请先选择所属广告系列组:</div>
                        <el-select
                            v-model="form.campaign_id" 
                            placeholder="输入广告系列名称或ID关键字搜索" 
                            class="width400"
                            filterable
                            :loading="searchCampaignLoading"
                            :disabled="(form.org_id == '' || apple_create_type == 'editGroup') ? true : false"
                            @visible-change="handleCampaignFocus"
                            @change="handleCampaignSelect"
                            ref="campaign_id"
                            size="mini"
                            >
                                <el-option
                                    v-for="item in filterCampaignOptions"
                                    :key="item.value"
                                    :label="item.campaign_name+'【'+item.campaign_id+'】'"
                                    :value="item.campaign_id">
                                </el-option>
                            </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom">{{errorsMsg['campaign_id']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>

        <div v-if="getShow" v-loading="editLoading">

        <div class="create_divider">
            <h2>广告组</h2>
        </div>
        <div class="create_list">
            <div class="create_title">基础信息</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">广告组名称：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['adgroup_name'] != '' ? true : false}">
                    <div class="ad_name_flex">
                        <el-input
                            placeholder="最多可输入200个字，不可以输入特殊符号"
                            v-model="form.adgroup_name"
                            :maxlength="200"
                            @input="handleAdNameInput(form.adgroup_name)"
                            @blur="handleAdName"
                            class="width400"
                            size="mini">
                        </el-input>
                        
                        <div class="num_length">{{form.adgroup_name.length}} / 200</div>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['adgroup_name']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">搜索匹配
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                搜索匹配是让你的广告启动并投放的最简单方法。我们会自动将你的广告与正在搜索你这类 app 的用户进行匹配。搜索匹配使用多种资源将你的广告与 App Store 中的相关搜索进行自动匹配，其中包括你的 App Store 详情中的元数据、同一类型中类似 app 的相关信息以及其他搜索数据。
                                <br/><span :style="{fontWeight: 'bolder'}">提示：优化元数据和图像。</span>
                                <br/>在决定显示哪个广告时会优先考虑相关性，因此，务必要精心设计你的 app 名称、图像、描述以及关键词，使它们具有吸引力和高度相关性。花点时间查看你的相关信息。对 app 元数据、图像及任何其他适用数据做出的更改可能要在最多 24 小时后显示在你的广告中。</div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <span :style="{paddingRight: '8px'}">自动将我的广告与相关搜索匹配</span>
                        <el-switch v-model="form.automated_keywords_opt_in" active-value="1" inactive-value="0" size="mini"></el-switch>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_PRODUCT_PAGES_BROWSE'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">App 类别：
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                你的广告可以在所有相关的 app 类别中投放，你也可以细化广告所投放的 app 类别。
                                <br/>所有类别：在所有相关 app 类别中展示广告。
                                <br/>类似类别：仅在与我的类别相似的 app 类别中展示广告。
                                <br/>其他类别：仅在与我的类别不同的 app 类别中展示广告。</div>
                            <span class="questions">?</span>
                        </el-tooltip>
                    </span>
                </div>
                <div class="create_action">
                        <el-radio-group v-model="form.app_categories" size="mini">
                            <el-radio label="3">所有类别</el-radio>
                            <el-radio label="2">类似类别</el-radio>
                            <el-radio label="1">其他类别</el-radio>
                        </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">投放时间</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">投放日期：</span></div>
                <div class="create_action" :style="{flex: '0 0 800px'}">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <div>
                        <el-radio-group size="mini" v-model="tfdate" @change="handletfdate">
                            <el-radio-button label="1">长期投放</el-radio-button>
                            <el-radio-button label="2">指定开始和结束日期</el-radio-button>
                        </el-radio-group>
                        </div>
                        <div>
                        <span class="font12px ml10 mr10 text-color-gray" v-if="form.time_zone=='Asia/Shanghai'">时区-上海</span>
                        <span class="font12px ml10 mr10 text-color-gray" v-else-if="form.time_zone=='UTC'">时区-UTC</span>
                        <!-- <el-select :value="form.time_zone" placeholder="请选择" @change="changeTimeZone"
                            :style="{width: '120px', marginLeft: '8px', marginRight: '8px', border: 'none'}" size="mini">
                            <el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>
                            <el-option label="时区-UTC" value="UTC">时区-UTC</el-option>
                        </el-select> -->
                        </div>
                    </div>
                    
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action" :style="{flex: '0 0 800px'}">
                    <div>
                        <div class="mb20">
                            <span :style="{paddingRight: '8px', color: '#606266'}">开始日期：</span>
                            <el-date-picker
                                align="right"
                                type="date"
                                placeholder="请选择开始日期"
                                :style="{width: '180px'}"
                                v-model="tf_start.start_date"
                                :picker-options="pickerStartOptions"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :disabled="apple_create_type == 'editGroup'"
                                size="mini">
                            </el-date-picker>
                            <el-time-picker
                                value-format="HH:mm"
                                format="HH:mm"
                                :picker-options="{format:'HH:mm'}"
                                :style="{width: '130px', marginLeft: '8px'}"
                                v-model="tf_start.start_time"
                                placeholder="选择时间"
                                :disabled="apple_create_type == 'editGroup'"
                                size="mini"
                                popper-class="de_time_picker">
                            </el-time-picker> 

                            <p class="create_err_bottom" :style="{paddingLeft: '68px'}">{{errorsMsg['tf_time']}}</p>
                        </div>

                        <div v-if="tfdate == 2" class="create_action_year" :class="{'is-error': errorsMsg['tf_time_2'] != '' ? true : false}">
                            <span :style="{paddingRight: '8px', color: '#606266'}">结束日期：</span>
                            <el-date-picker
                                align="right"
                                type="date"
                                placeholder="请选择结束日期"
                                :style="{width: '180px'}"
                                v-model="tf_end.start_date"
                                :picker-options="pickerEndOptions"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                size="mini">
                            </el-date-picker>
                            <el-time-picker
                                value-format="HH:mm"
                                format="HH:mm"
                                :picker-options="{format:'HH:mm'}"
                                :style="{width: '130px', marginLeft: '8px'}"
                                v-model="tf_end.start_time"
                                placeholder="选择时间"
                                size="mini"
                                popper-class="de_time_picker">
                            </el-time-picker>
                            <p class="create_err_bottom" :style="{paddingLeft: '68px'}">{{errorsMsg['tf_time_2']}}</p>
                        </div>
                    </div>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">投放时段
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                选择何时向用户展示广告。投放时间设置基于用户的本地时区。
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="tftime">
                        <el-radio-button label="1">不限</el-radio-button>
                        <el-radio-button label="2">指定时段</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS' && tftime == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action" :style="{flex: '0 0 700px'}">
                    <div>
                        <DropTimes @getdaypart="getdaypart" ref="dropTimes"></DropTimes>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['daypart']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">出价</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">默认最高每次点击付费出价
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                默认最高每次点击付费出价 这是你愿意为每次广告点击支付的最高金额。该出价将应用于此广告组中的所有关键词，除非你设置了单独的关键词出价。<br/><br/>
                                提示：从你所知道的平均用户价值入手。例如：如果你能支付 2.50 美元来获取一位用户，并且估计点击广告的用户中有 40% 会下载 app，那么你可以针对每次点击支付 2.50 美元的 40%，也就是支付 1.00 美元。
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action" :class="{'is-error': errorsMsg['default_bid_amount'] != '' ? true : false}">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <el-input 
                        v-model="form.default_bid_amount" 
                        @input="(value)=>handleInput(value, 'default_bid_amount')"
                        @blur="(event) => handleRequiredBlur(event, 'default_bid_amount', form.default_bid_amount)"
                        @change="handleamount"
                        placeholder="请输入出价金额，不可大于广告系列的每日预算"
                        size="mini"
                        class="width400">
                        </el-input>
                        <span class="normal-text ml10">{{daily_budget_currency}}</span>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['default_bid_amount'] || getBIdAmountBottomErrorMsg}}</p>
                </div>
                <div class="create_err_right" :style="{paddingLeft: '8px'}">{{getBIdAmountErrorMsg}}</div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">每次转化费用上限
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                该可选设置指定了你愿意为每次转化支付的金额，并将为你广告组中所有关键词设置出价上限。
                                <br/><br/>该上限的计算方式如下：每次转化费用上限 x 转化率
                                <br/><br/>如果关键词的最高每次点击付费出价低于上述等式的结果，则系统会应用该最高每次点击付费出价。
                                <br/><br/>例如，如果每次转化费用上限为 5 美元，转化率为 65%，则系统为广告组中所有关键词应用的最高出价为 3.25 美元。如果最高每次点击付费设置为 4 美元，则系统会应用的最高出价仍为 3.25 美元。
                                <br/><br/>每次转化费⽤上限会限制展示次数和转化次数，你可以自行决定是否进行相关设置。
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <el-input 
                        v-model="form.cpa_goal" 
                        @input="(value)=>handleInput(value, 'cpa_goal')"
                        placeholder="请输入出价金额，不可大于广告系列的每日预算"
                        size="mini"
                        class="width400">
                        </el-input>
                        <span class="normal-text ml10">{{daily_budget_currency}}</span>
                    </div>
                    <p class="create_err_bottom">{{getCpaGoalErrorMsg}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS' && this.apple_create_type != 'editGroup'">
            <!-- v-if="supply_source == 'APPSTORE_SEARCH_TAB'" -->
            <div class="create_title">关键词</div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">添加关键词
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                关键词是用户在搜索你这类 app 时可能使用的相关词或短语。你可以对任何关键词单独出价，以优化投资回报。广泛匹配将自动包含同义词和含该术语的短语等变体，以及常见的拼写错误和复数形式，因此你无需添加这些。
                                <br/><br/><span :style="{fontWeight: 'bolder'}">提示：使用搜索匹配</span>这是一个发掘相关关键词的好方法，这些关键词会为你的 app 增加展示次数、点击次数和转化次数，所以你不必考虑所有的可能性。
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div>
                        <el-button type="text" @click="showKeywordModal">点击添加</el-button>
                    （已添加 {{keyword.length}} 个广告组关键词）
                        <span v-if="this.apple_create_type != 'editGroup'" class="text-color-error pointer font12px ml20" @click="clearKeyword">清空</span>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">添加否定关键词
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                否定关键词可防止你的广告在这些词的搜索结果中显示。
                                <br/><br/>例如，如果你添加“免费”作为否定关键词，则你的广告不会出现在使用“免费”这个词执行的搜索中。你添加的否定关键词仅适用于此广告组。在广告系列级别设置否定关键词，以将其应用于所有广告组。
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div>
                        <el-button type="text" @click="showNegativeKeywordModal">点击添加</el-button>
                        （已添加 {{negative_keyword.length}} 个广告组否定关键词）
                        <span v-if="this.apple_create_type != 'editGroup'" class="text-color-error pointer font12px ml20" @click="clearNegativeKeyword">清空</span>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">受众</div>
            <!-- <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">受众:</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="targeting_type">
                        <el-radio-button label="1">不限</el-radio-button>
                        <el-radio-button label="2">特定受众</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div> -->
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">设备：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['device_class'] != '' ? true : false}">
                    <el-select v-model="device_class" 
                    multiple
                    remote 
                    reserve-keyword 
                    collapse-tags
                    placeholder="请选择"
                    @change="(value)=>handleallchange(value, 'device_class')"
                    class="width400"
                    size="mini"
                    >
                        <el-option :label="item.label" :value="item.value" v-for="(item, index) in device_class_list" :key="index"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['device_class']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">用户类型：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['app_downloader'] != '' ? true : false}">
                    <el-select 
                    v-model="sz_Form.app_downloader" 
                    placeholder="请选择"
                    @change="(value)=>handleallchange(value, 'app_downloader')"
                    size="mini"
                    class="width400">
                        <!-- <el-option label="全部" value="3"></el-option>
                        <el-option label="新用户" value="1"></el-option>
                        <el-option label="我的其他APP的用户" value="4"></el-option>
                        <el-option label="回访用户" value="2"></el-option> -->
                        <el-option :label="item.label" :value="item.value" v-for="(item, index) in app_downloader_list" :key="index"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['app_downloader']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-show="targeting_type == '2' && sz_Form.app_downloader == '4'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <div>
                            <el-button type="text" @click="handleSelectOutApp">选择我其他的App
                                <el-tooltip
                                    effect="dark"
                                    placement="top"
                                    :open-delay="500"
                                    >
                                    <div slot="content">
                                        面向你的一个或多个其他 app 的用户交叉推广你的 app。
                                    </div>
                                    <span class="questions">?</span>
                                </el-tooltip>
                            </el-button>
                        </div>
                        <span :style="{color: 'rgb(118 118 118)', paddingLeft: '8px'}">已添加{{sz_Form.app_downloader_apps && sz_Form.app_downloader_apps.length}}个其他的App</span>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['outApp']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">性别：</span></div>
                <div class="create_action">
                    <el-select 
                    v-model="sz_Form.gender" 
                    class="width400"
                    placeholder="请选择"
                    @change="(value)=>handleallchange(value, 'gender')"
                    size="mini">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['gender']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">年龄：</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="age_type">
                        <el-radio-button label="1">不限</el-radio-button>
                        <el-radio-button label="2">指定年龄段</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && age_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <div>
                        <el-select 
                        v-model="ageForm.start" 
                        placeholder="请选择" 
                        :style="{width: '120px', marginRight: '10px'}"
                        @change="handleAgeStart"
                        class="create_action_year"
                        :class="{'is-error': errorsMsg['ageForm_start'] != '' ? true : false}"
                        size="mini">
                            <el-option :label="item" :value="item" v-for="(item, index) in startYear" :key="index"></el-option>
                        </el-select>
                        <span>-</span>
                        <el-select v-model="ageForm.end" 
                        placeholder="请选择" 
                        :style="{width: '120px', marginLeft: '10px'}"
                        @change="handleAgeEnd"
                        class="create_action_year"
                        :class="{'is-error': errorsMsg['ageForm_end'] != '' ? true : false}"
                        size="mini">
                            <el-option :label="item" :value="item" v-for="(item, index) in endYear" :key="index"></el-option>
                            <el-option label="65+" :value="Number(65)"></el-option>
                        </el-select>
                    </div>
                    <p class="create_err_bottom posi">{{errorsMsg['ageForm_start']}}</p>
                    <p class="create_err_bottom posi" :style="{left: '144px'}">{{errorsMsg['ageForm_end']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" :style="{paddingBottom: '20px'}" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">地理位置：</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="positioning_type">
                        <el-radio-button label="1">不限</el-radio-button>
                        <el-radio-button label="2">指定地理位置</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom">{{errorsMsg['country']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" :style="{paddingBottom: '10px'}" v-if="targeting_type == '2' && positioning_type == '2'">
                <p :style="{color: '#606266', paddingLeft: '220px'}">请输入至少两个字搜索地理位置</p>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>国家</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.country" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword
                        collapse-tags
                        :loading="searchCountryLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'country')"
                        placeholder="按照国家名称搜索"
                        :disabled="!ciryerror"
                        @change="(value)=>handleallchange(value, 'country')"
                        size="mini"
                        class="width400">
                            <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in countryOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>省/自治区/直辖市</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.admin_area" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword
                        :loading="searchAdminLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'admin_area')"
                        collapse-tags
                        placeholder="按照省/自治区/直辖市名称搜索"
                        :disabled="!ciryerror"
                        @change="(value)=>handleallchange(value, 'admin_area')"
                        size="mini"
                        class="width400">
                        <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in areaOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>城市</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.locality" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword 
                        collapse-tags
                        :loading="searchLocalityLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'locality')"
                        placeholder="按照城市名称搜索"
                        @change="(value)=>handleallchange(value, 'locality')"
                        :disabled="!ciryerror"
                        size="mini"
                        class="width400">
                        <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in localityOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>

        </div>

        </div>

        <!-- 添加关键词 -->
        <keywordModal ref="keywordModal" 
        action-type="adGroupAddKeyword"
        :action-rows="keyword"
        :currency-text="daily_budget_currency"
        :form-data="actionRowData"
        @save="saveKeyword"
        />
        <!-- 添加否定关键词 -->
        <NegativeKeywordModal 
        ref="negativeKeywordModal" 
        action-type="adGroupAddNegativeKeyword"
        :action-rows="negative_keyword"
        :form-data="actionRowData"
        @save="saveNegativeKeyword"/>
        <!-- 选择我的其他App -->
        <appModal ref="appModal" :select="sz_Form.app_downloader_apps" @getOutApp="getOutApp"></appModal>
        <el-dialog
            :title="null"
            :visible.sync="dialogVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                <p class="tac text-color-error pt10 pb20">请勿刷新页面，刷新页面会导致无法及时收到最新结果</p>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index';
    import DropTimes from '../components/dropTimes.vue'
    import appModal from './modal/appModal.vue'
    import keywordModal from '../keywords/modal/keywordModal';
    import NegativeKeywordModal from '../keywords/modal/negativeKeywordModal';
    import {
        get_create_ad_err_html,
        get_flag_suc_html
    } from "../components/getFlagHtml.js";
    import { throttle } from 'lodash'
    //                             o8888888o
    //                             88" . "88
    //                             (| -_- |)
    //                              O\ = /O
    //                           ____/`---'\____
    //                        .   ' \\| |// `.
    //                         / \\||| : |||// \
    //                        / _||||| -:- |||||- \
    //                         | | \\\ - /// | |
    //                       | \_| ''\---/'' | |
    //                        \ .-\__ `-` ___/-. /
    //                    ___`. .' /--.--\ `. . __
    //                  ."" '< `.___\_<|>_/___.' >'"".
    //                 | | : `- \`.;`\ _ /`;.`/ - ` : | |
    //                    \ \ `-. \_ __\ /__ _/ .-` / /
    //           ======`-.____`-.___\_____/___.-`____.-'======
    export default {
        name: 'create_apple_ad_group',
        components: {
            DropTimes,
            appModal,
            keywordModal,
            NegativeKeywordModal
        },
        props: ['org','campaign'],
        inject:['priceDecimalConfig'],
        data() {
            return {
                show:false,  //广告组是否显示
                editLoading: false,  //编辑loading
                disabled:true,
                pickerStartOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                pickerEndOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                filterOrgOptions: [],
                searchOrgLoading: false,
                filterCampaignOptions: [],
                searchCampaignLoading: false,
                prev_org_id: '',
                prev_campaign_id: '',
                supply_source: '',   //投放位置信息  很重要 处理 选项是否预算
                countries_or_regions: '', //位置国家 地区 很重要
                countries_or_regions_support_target:false, //是否支持  true 支持  false不支持
                prev_start_time: '',  //上一级广告组开始时间
                prev_end_time: '',    //上一级广告组结束时间
                form: {
                    org_id: '',        // 所属广告系列组
                    org_name: '',
                    campaign_id: '',  //所属广告系列
                    campaign_name: '',
                    adgroup_name: '',   //  广告组名称
                    automated_keywords_opt_in: '1',  // 搜索匹配 0是关 1是开
                    app_categories: '3',          //App 类别 3所有类别，2类似类别，1其他类别
                    time_zone: 'Asia/Shanghai',  //时区切换
                    start_time: '',      // 投放日期 开始日期
                    end_time: '',       // 投放日期 结束日期
                    daypart: [],       // 投放时段
                    default_bid_amount: '', //默认最高每次点击付费出价
                    cpa_goal: '',   //每次转化费用上限
                },
                keyword: [],     // 关键词
                negative_keyword: [],   //否定关键词
                tfdate: '1',      //投放日期 1 长期投放  2 指定开始和结束日期
                tftime: '1',       //投放时段
                targeting_type: '2',       // 受众   1不限  2特定受众
                age_type: '1',   //年龄 tab 切换
                positioning_type: '1',   //地理位置 tab 切换
                tf_start: {
                    start_date: '',     //投放日期 开始日期
                    start_time: '',     //投放日期 开始日期 时间
                },
                tf_end: {
                    start_date: '',       //投放日期 结束日期
                    start_time: '',       //投放日期 结束日期 时间
                },
                device_class: '',   //  全部 ['IPAD', 'IPHONE']  IPAD IPHONE  特殊处理
                device_class_list: [],
                app_downloader_list: [],  //用户类型
                sz_Form: {
                    app_downloader: '',   // 用户类型:3-所有用户,1-新用户,2-回访用户,4-我的其他APP
                    app_downloader_apps: [],  // 用户类型为我的其他APP时选择的产品
                    gender: ''              //M 男 F女
                },
                ageForm: {
                    start: '',
                    end: ''
                },
                startYear:[],
                endYear:[],
                positioningForm: {       
                    country: [],
                    admin_area: [],
                    locality: []
                },
                errorsMsg: {
                    org_id: '',
                    campaign_id: '',
                    adgroup_name: '',
                    tf_time: '',
                    tf_time_2: '',
                    daypart: '',
                    default_bid_amount:'',
                    device_class: '',
                    app_downloader: '',
                    outApp: '',
                    ageForm_start: '',
                    ageForm_end: '',
                    country: '',
                    admin_area: '',
                    locality: ''
                },   //错误的校验信息
                countryOptions: [],   //国家下拉框
                areaOptions: [],   //省 自治区
                localityOptions: [],   //城市下拉框
                avg_default_bid_amount: '',  //平均值
                daily_budget: 0,
                daily_budget_currency: '元',  //单位
                cpa_goal:0,
                big_daily_budget : 0,
                errTips: '必填项不可为空',
                dialogVisible: false,   //各种错误提示
                dialogTypeTitle: '',
                apple_create_type: '',
                searchCountryLoading: false,
                searchAdminLoading: false,
                searchLocalityLoading: false,
                adgroup_id:'',
                adname_mul:false
            }
        },
        computed:{
            ...mapGetters(['cur_tab_page']),
            decimalConfig(){
                return this.priceDecimalConfig();
            },
            getShow: function() {
                if(this.form.campaign_id != '') {
                    return true
                }else{
                    return false
                }
            },
            getBIdAmountBottomErrorMsg: function() {
                if(Number(this.daily_budget) != 0 && Number(this.daily_budget) < Number(this.form.default_bid_amount)) {
                    return '不可大于上级广告系列的预算，请重新输入'
                }else if(Number(this.big_daily_budget)  < Number(this.form.default_bid_amount)){
                    return '不可大于默认最高出价，请重新输入'
                }
            },
            getBIdAmountErrorMsg: function() {
                if(Number(this.avg_default_bid_amount) < Number(this.form.default_bid_amount)) {
                    let average = Number(this.form.default_bid_amount) - Number(this.avg_default_bid_amount)
                    let pix = ( (( Number(this.form.default_bid_amount) - Number(this.avg_default_bid_amount) ) / Number(this.avg_default_bid_amount)) * 100).toFixed(2)
                    if(pix == 'Infinity') {
                        return ``
                    }else{
                        return `输入的出价超出账户平均出价${average} ${this.daily_budget_currency}（${pix}%），请核实！`
                    }
                }else{
                    return ''
                }
            },
            getCpaGoalErrorMsg: function() {
                if(Number(this.cpa_goal) != 0) {
                    if(Number(this.cpa_goal) < Number(this.form.cpa_goal)) {
                        return '不可大于默认最高出价，请重新输入'
                    }
                    // if(Number(this.daily_budget) < Number(this.form.cpa_goal)) {
                    //     return '不可大于上级广告系列的预算，请重新输入'
                    // }
                }else{
                    return ''
                }
            },
            ciryerror: function() {
                let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2
                if(nums > 1 || !this.countries_or_regions_support_target) {
                    return false
                }else{
                    return true
                }
            },
            ciryshow: function() {
                let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2
                if(this.countries_or_regions_support_target) {
                    if(nums > 1) {
                        return '投放多个国家或地区时，不支持细分地理位置'
                    }else{
                        return ''
                    }
                }else{
                    return '当前选择的国家或地区，不支持细分地理位置'
                }
            },
            actionRowData(){
                return {
                    org_id:this.form.org_id,
                    org_name:this.filterOrgOptions.filter(item=>item['org_id'] == this.form.org_id).map(item=>item.org_name)[0],
                    campaign_id:this.form.campaign_id,
                    campaign_name:this.filterCampaignOptions.filter(item=>item['campaign_id'] == this.form.campaign_id).map(item=>item.campaign_name)[0]
                }
            },
        },
        watch: {
            'tf_start.start_date': {
                handler(newVal, oldVal) {
                    this.concat_start_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_start.start_time': {
                handler(newVal, oldVal) {
                    this.concat_start_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_end.start_date': {
                handler(newVal, oldVal) {
                    this.concat_end_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_end.start_time': {
                handler(newVal, oldVal) {
                    this.concat_end_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'form.start_time': {
                handler(newVal, oldVal) {
                    this.handleRequiredDate()
                },
                deep: true, // 深度监听
            },
            'form.end_time': {
                handler(newVal, oldVal) {
                    this.handleRequiredDate()
                },
                deep: true, // 深度监听
            },
            'form.daypart'(newValue) {
                if(this.tftime == '2') {
                    let result_value = (Array.isArray(newValue) && newValue.length == 0) ? '' : newValue.length
                    this.validateItem('daypart', result_value, 
                        [
                            { required: true, message: '必填项不可为空'},
                        ]
                    );
                }
            },
            org: {
                handler(newVal, oldVal) {
                    // 在对象发生变化时执行的操作
                    if(newVal && newVal.list.length != 0 && this.apple_create_type != 'editGroup') {
                        this.filterOrgOptions = newVal.list
                        // this.prev_org_id = newVal['id'] ? newVal['id'].toString() : ''
                        this.form.org_id = newVal['id'] ? newVal['id'].toString() : ''
                        // this.form.org_id = newVal.list[0]['org_id']
                        if(this.form.org_id != '') {
                            this.prev_campaign_id = ''
                            this.form.campaign_id = '' 
                            this.handleCampaignFocus_new('')
                        }
                        
                    }else{
                        this.handleOrgFocus_new()
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            },
            campaign: {
                handler(newVal, oldVal) {
                    // 在对象发生变化时执行的操作
                    if(newVal && newVal.list.length != 0) {
                        // this.filterCampaignOptions = newVal.list
                        this.prev_campaign_id = newVal.list[0]['campaign_id'] ? newVal.list[0]['campaign_id'].toString() : ''
                        this.form.campaign_id =  newVal.list[0]['campaign_id'] ? newVal.list[0]['campaign_id'].toString() : ''
                        // this.getOutInfo(this.form.org_id, this.form.campaign_id)
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            }
        },

        mounted() {
            this.apple_create_type = this.$store.getters.apple_create_type
            // this.handleOrgFocus_new()
            if(this.apple_create_type == 'editGroup') {
                let editInfo = this.$store.getters.apple_edit_info
                // 获取编辑状态下的详情
                this.adgroup_id = editInfo['adgroup_id']
                this.getEditInfo(editInfo['org_id'], editInfo['adgroup_id'], editInfo['campaign_id'])
            }
            // 将滚动位置设置为页面顶部
            window.scrollTo(0, 0);
        },
        methods: {
            getEditInfo(org_id, adgroup_id, campaign_id) {
                this.$emit('postresult', {loading: true, dialog: false, success: false,});
                this.editLoading = true
                API.get_create_campaign_info({org_id: org_id, campaign_id: campaign_id}).then(res=>{
                    let result = res.data
                    this.form.time_zone = result.config['time_zone']
                    this.app_downloader_list = result['app_downloader_select_list'] ? result['app_downloader_select_list'].map(item=>{
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }) : []

                    this.daily_budget_currency = result.config.currency
                    this.daily_budget = result.daily_budget
                    this.cpa_goal = result.config.cpa_goal
                    this.big_daily_budget = result.config['default_bid_amount']

                    this.countries_or_regions = result['countries_or_regions']
                    this.countries_or_regions_support_target = result['countries_or_regions_support_target']
                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
                API.get_create_adgroup_info({org_id: org_id, adgroup_id: adgroup_id}).then(res=>{
                    let reslute = res.data

                    this.filterOrgOptions = [{value: reslute['org_id'], label: reslute['org_name']}]
                    this.filterCampaignOptions = [{campaign_id: reslute['campaign_id'], campaign_name: reslute['campaign_name']}]


                    this.form.org_id = reslute['org_id'] ? reslute['org_id'].toString() : ''
                    this.form.org_name = reslute['org_name']
                    this.form.campaign_id = reslute['campaign_id'] ? reslute['campaign_id'].toString() : ''
                    this.form.campaign_name = reslute['campaign_name']
                    this.supply_source = reslute['supply_source']
                    this.form.app_categories = reslute['app_categories'] ? reslute['app_categories'].toString() : ''

                    this.get_app_eligibility(reslute['adam_id'], reslute['org_id']).then(()=>{
                        this.form.adgroup_name = reslute['adgroup_name']
                        this.form.automated_keywords_opt_in = reslute['automated_keywords_opt_in']
                        
                        
                        
                        if(reslute['end_time']) {
                            this.tfdate = '2'

                            let split_data_start = reslute['start_time'] ? reslute['start_time'].split(' ') : ''
                            this.tf_start.start_date = split_data_start[0]
                            this.tf_start.start_time = split_data_start[1]

                            let split_data_end = reslute['end_time'] ? reslute['end_time'].split(' ') : ''
                            this.tf_end.start_date = split_data_end[0]
                            this.tf_end.start_time = split_data_end[1]

                            this.form.start_time = reslute['start_time']
                            this.form.end_time = reslute['end_time']

                        }else{
                            let split_data_start = reslute['start_time'] ? reslute['start_time'].split(' ') : ''
                            this.tf_start.start_date = split_data_start[0]
                            this.tf_start.start_time = split_data_start[1]

                            this.form.start_time = reslute['start_time']
                        }

                        if(reslute['daypart'] && reslute['daypart'].length != 0) {
                            this.tftime = '2'
                            
                            this.$nextTick(()=>{
                                this.form.daypart = reslute['daypart']
                                this.$refs.dropTimes.getIdToString(reslute['daypart'])
                            })
                        }

                        if(reslute['default_bid_amount']) {
                            this.form.default_bid_amount = reslute['default_bid_amount']
                        }
                        if(reslute['cpa_goal']) {
                            let zore_cpa_goal = (Number(reslute['cpa_goal']) === 0 || reslute['cpa_goal'] == '-') ? '' : reslute['cpa_goal']
                            this.form.cpa_goal = zore_cpa_goal
                        }
                        if(reslute['keyword']) {
                            this.keyword = reslute['keyword']
                        }
                        if(reslute['negative_keyword']) {
                            this.negative_keyword = reslute['negative_keyword']
                        }

                        if(reslute['device_class']) {
                            this.targeting_type = 2
                            // if(reslute['device_class'].length == 2) {
                            //     this.device_class = '1'
                            // }else{
                            //     this.device_class = reslute['device_class']
                            // }
                            this.device_class = reslute['device_class']
                        }

                        if(reslute['app_downloader'] && reslute['app_downloader'] == '4') {
                            this.sz_Form.app_downloader = reslute['app_downloader'] ? reslute['app_downloader'].toString() : ''
                            this.sz_Form.app_downloader_apps = reslute['app_downloader_apps'].map(item=>{
                                return {
                                    adam_id: item.adam_id ? item.adam_id.toString() : '',
                                    app_name: item.app_name
                                }
                            })
                        }else if(reslute['app_downloader'] && reslute['app_downloader'] != '4'){
                            this.sz_Form.app_downloader = reslute['app_downloader'] ? reslute['app_downloader'].toString() : ''
                        }

                        if(reslute['gender']) {
                            this.sz_Form.gender =  reslute['gender'] ? reslute['gender'].toString() : ''
                        }

                        if(reslute['age']) {
                            if(reslute['age'].length == 0) {
                                this.age_type = '1'
                            }else{
                                this.age_type = '2'
                                if(reslute['age'].length == 1) {
                                    this.ageForm.start = reslute['age'][0] ? reslute['age'][0].toString() : ''
                                    this.ageForm.end = 65
                                }else if(reslute['age'].length == 2){
                                    this.ageForm.start = reslute['age'][0] ? reslute['age'][0].toString() : ''
                                    this.ageForm.end = reslute['age'][1] ? reslute['age'][1].toString() : ''
                                }
                            }
                        }
                        
                        if(reslute['country'] && reslute['country'].length != 0) {
                            this.positioning_type = '2'
                            this.countryOptions = reslute['country']
                            this.positioningForm.country = reslute['country'].map(item=>item.id)
                        }
                        if(reslute['admin_area'] && reslute['admin_area'].length != 0) {
                            this.positioning_type = '2'
                            this.areaOptions = reslute['admin_area']
                            this.positioningForm.admin_area = reslute['admin_area'].map(item=>item.id)
                        }
                        if(reslute['locality'] && reslute['locality'].length != 0) {
                            this.positioning_type = '2'
                            this.localityOptions = reslute['locality']
                            this.positioningForm.locality = reslute['locality'].map(item=>item.id)
                        }
                        this.editLoading = false
                        this.$emit('postresult', {loading: false, dialog: false, success: false,});
                    })
                }, err=>{
                    this.editLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});
                })
            },
            getMsgTime() {
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let cday = date.getDate()
                return `${year}-${month}-${cday}`
            },
            // 清空重置
            resetForm() {
                this.errorsMsg.org_id = ''
                this.errorsMsg.campaign_id = ''
                this.errorsMsg.adgroup_name = ''
                this.errorsMsg.tf_time = ''
                this.errorsMsg.tf_time_2 = ''
                this.errorsMsg.daypart = ''
                this.errorsMsg.default_bid_amount =''
                this.errorsMsg.device_class = ''
                this.errorsMsg.app_downloader = ''
                this.errorsMsg.outApp = ''
                this.errorsMsg.ageForm_start = ''
                this.errorsMsg.ageForm_end = ''
                this.errorsMsg.country = ''
                this.errorsMsg.admin_area = ''
                this.errorsMsg.locality = ''

                this.positioningForm.country = '',
                this.positioningForm.admin_area = ''
                this.positioningForm.locality = ''

                this.ageForm.start = ''
                this.ageForm.end = ''

                // this.form.org_id= ''
                // this.form.campaign_id= ''
                this.form.adgroup_name= ''
                this.form.automated_keywords_opt_in= '1'
                this.form.app_categories= '3'
                this.form.time_zone= 'Asia/Shanghai'
                // this.form.start_time= ''
                this.form.end_time= ''
                this.form.daypart= []
                this.form.default_bid_amount= ''
                this.form.cpa_goal= ''

                this.tfdate = '1'
                this.tftime = '1'
                this.targeting_type = '2'
                this.age_type = '1'
                this.positioning_type = '1'
            },
            // 单独校验
            validateItem(fieldName, value, rules) {
                // this.errorsMsg[fieldName] = '';
                // this.$set(this.errorsMsg, fieldName, '');
                try {
                    rules.forEach(item=> {
                            if (item['required'] && !value) {
                                this.errorsMsg[fieldName] = item.message
                                console.log(fieldName, item.message)
                                throw('终止')
                            }else{
                                if(item['max'] && value.length > item['max']) {
                                    this.errorsMsg[fieldName] = item.message
                                }else if(item['reg']) {
                                    let reg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|[^\x00-\x7F\xA0-\uD7FF\uE000-\uFFFF]/;
                                    let otherReg = /^[^[\];{}"<>]*$/;
                                    if(reg.test(value) || !otherReg.test(value)) {
                                        this.errorsMsg[fieldName] = item.message
                                    }
                                }else{
                                    this.errorsMsg[fieldName] = ''
                                }
                            }
                    })
                } catch(e) { console.log('e',e) }
            },
            // 校验清空
            clearValidateItem(fieldName) {
                this.errorsMsg[fieldName] = ''
            },
            // 触发校验
            handleRequiredBlur(event, validateName, current_value) {
                let result_value = event.target.value || current_value
                this.validateItem(validateName, result_value, 
                    [
                        { required: true, message: '必填项不可为空'},
                    ]
                );
            },
            // 投放日期 校验
            handleRequiredDate() {
                if(this.tfdate == 1) {
                    let result_start = 1000000000000000000

                    if(this.tf_start.start_date && this.tf_start.start_time) {
                        result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                    }else{
                        result_start = 0
                    }

                    let prev_endtime = this.prev_end_time ? new Date(this.prev_end_time).valueOf() : 0

                    let validateName = 'tf_time'
                    let result_value = ''
                    let msg = ''
                    if(prev_endtime != 0 && result_start > prev_endtime) {
                        msg = '开始日期与时间不可大于上级广告系列的结束日期与时间'
                    }else if(result_start == 0){
                        msg = '必填项不可为空'
                    }else{
                        result_value = '10'
                        msg = ''

                    }
                    this.validateItem(validateName, result_value, 
                        [
                            { required: true, message: msg},
                        ]
                    );
                    return
                }
                let prev_starttime = this.prev_start_time ? new Date(this.prev_start_time).valueOf() : 0

                let result_start = 1000000000000000000
                let result_end = 1000000000000000000
                if(this.tf_start.start_date && this.tf_start.start_time) {
                    result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                }else{
                    result_start = 0
                }

                if(this.tf_end.start_date && this.tf_end.start_time) {
                    result_end = this.form.end_time ? new Date(this.form.end_time).valueOf() : 0
                }else{
                    result_end = 0
                }

                let validateName = 'tf_time_2'
                let result_value = ''
                let msg = '必填项不可为空'
                if(result_start != 0 && result_end != 0) {
                    if(result_start >= result_end) {
                        this.errorsMsg.tf_time_2 = ''
                        msg = '结束日期不可早于开始日期与时间'
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }else if(prev_starttime != 0 && prev_starttime > result_end) {
                        this.errorsMsg.tf_time_2 = ''
                        msg = '结束日期与时间不可小于上级广告系列的开始日期与时间'
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }else{
                        this.errorsMsg.tf_time_2 = ''
                        result_value = '10'
                        msg = ''
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }
                }else{
                    result_value = ''
                    msg = '必填项不可为空'
                    this.validateItem('tf_time_2', result_value, 
                        [
                            { required: true, message: msg},
                        ]
                    );
                }
                
            },
            // 所属广告系列组 
            handleOrgFocus_new() {
                if(this.filterOrgOptions.length == 0) {
                    this.searchOrgLoading = true
                    API.getOrgSelectorList({ search: '',source_page:this.cur_tab_page }).then(res => {
                        let result = res.data ? res.data : []
                        // this.filterOrgOptions = result
                        let resultList = result.map(item=>{
                            return {
                                value:item.org_id,
                                label:item.org_name,
                            }
                        });
                        // this.prev_org_id = this.form.org_id
                        this.$emit('postOrg', {
                            id: '',
                            list: resultList
                        })
                        this.searchOrgLoading = false
                    },err => {
                        this.searchOrgLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$emit('postOrg', {
                            id: '',
                            list: []
                        })
                        this.$message.error(err.info);
                    })
                } 
            },
            // 所属广告系列组 下拉
            remoteMethodOrg(query) {
                if (query == '') {
                    return
                }
                this.searchOrgLoading = true
                API.getOrgSelectorList({ search: query,source_page:this.cur_tab_page, }).then(res => {
                    let result = res.data ? res.data : []
                    // this.filterOrgOptions = result
                    let resultList = result.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.$emit('postOrg', {
                        id: '',
                        list: resultList
                    })
                    this.searchOrgLoading = false
                },err => {
                    this.searchOrgLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 缓存上一次选择
            handleOrgFocus(val) {
                // if (val) {
                //     console.log('shangyici', this.form.org_id, val)
                //     this.prev_org_id = this.form.org_id
                // }
            },
            // 所属广告系列组 change 事件
            handleOrgSelect(value) {
                if(this.form.campaign_id != '') {
                    this.$confirm('修改广告系列组，已填写的内容将会被清空', '提示', {
                        confirmButtonText: '确认',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                        }).then(() => {
                            this.$refs.org_id.blur()
                            this.resetForm()
                            this.clearValidateItem('org_id')

                            this.form.org_id = value
                            this.$emit('postOrg', {
                                id: this.form.org_id,
                                list: this.filterOrgOptions
                            })

                        }).catch(() => {
                            console.log('000', this.prev_org_id)
                            this.form.org_id = this.prev_org_id
                            this.$refs.org_id.blur()
                            // this.loading = false
                            // this.$emit('postOrg', {
                            //     id: this.prev_org_id,
                            //     list: this.filterOrgOptions
                            // })
                    });
                }else {
                    this.resetForm()
                    this.clearValidateItem('org_id')
                    this.form.org_id = value
                    this.$emit('postOrg', {
                        id: this.form.org_id,
                        list: this.filterOrgOptions
                    })

                }
                // console.log('-000', value)
                // this.form.org_id = value
                // let org_item = this.filterOrgOptions.filter(item=>item.org_id == value)
                // this.$emit('postresult', {loading: false, dialog: false, success: false, org_list: {type:'group' ,list:org_item}})
                // this.$emit('postOrg', {
                //     id: this.form.org_id,
                //     list: this.filterOrgOptions
                // })
                // API.getCampaignSelectorList({ search: '', org_id: value,source_page:this.cur_tab_page}).then(res => {
                //     let result = res.data
                //     this.filterCampaignOptions = result
                //     this.form.campaign_id = ''
                //     this.searchCampaignLoading = false
                // },err => {
                //     this.searchCampaignLoading = false
                //     this.$message.error(err.info);
                // })
                // this.form.org_id = value

            },
            handleCampaignFocus_new(query) {
                this.prev_org_id = this.form.org_id
                this.searchCampaignLoading = true
                API.getCampaignSelectorList({ search: query,source_page:this.cur_tab_page, org_id: this.form['org_id']}).then(res => {
                    let result = res.data
                    this.filterCampaignOptions = result

                    if(this.form.campaign_id) {
                        let ispull = this.filterCampaignOptions.some(item=>item.campaign_id == this.form.campaign_id)
                        if(ispull) {
                            this.getOutInfo(this.form.org_id, this.form.campaign_id)
                        }
                    }else{
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, org_list: {type:'group' ,list:org_item}})
                    }
                    this.searchCampaignLoading = false
                },err => {
                    this.searchCampaignLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 所属广告系列 下拉
            remoteMethodCampaign(query) {
                if (query == '') {
                    return
                }
                this.searchCampaignLoading = true
                API.getCampaignSelectorList({ search: query,source_page:this.cur_tab_page, org_id: this.form['org_id']}).then(res => {
                    let result = res.data
                    this.filterCampaignOptions = result
                    this.searchCampaignLoading = false
                },err => {
                    this.searchCampaignLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 缓存上一次选择
            handleCampaignFocus(val) {
                // if (val) {
                //     this.prev_campaign_id = this.form.campaign_id
                // }
            },
            // 所属广告系列 change 事件
            handleCampaignSelect(value) {
                if(this.prev_campaign_id != '') {
                    if(this.prev_campaign_id != value) {
                        this.$confirm('修改广告系列，已填写的内容将会被清空', '提示', {
                            confirmButtonText: '确认',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                            }).then(() => {
                                this.form.campaign_id = value
                                this.prev_campaign_id = value
                                this.$refs.campaign_id.blur()
                                this.resetForm()
                                this.clearValidateItem('campaign_id')
                                this.getOutInfo(this.form.org_id, value)
                            }).catch(() => {
                                // this.loading = false
                                this.form.campaign_id = this.prev_campaign_id
                                this.$refs.campaign_id.blur()
                        });
                    }
                    
                }else{
                    // this.resetForm()
                    this.clearValidateItem('campaign_id')
                    this.form.campaign_id = value
                    this.prev_campaign_id = value
                    this.getOutInfo(this.form.org_id, value)
                }
                // this.form.campaign_id = value
                // if(value) {   
                // }else{
                //     this.resetForm()
                //     this.clearValidateItem('campaign_id')
                // }
            },
            getOutInfo(org_id, campaign_id) {
                this.editLoading = true
                let org_item = this.filterOrgOptions.filter(item=>item.org_id == org_id)
                this.$emit('postresult', {loading: false, dialog: true, success: false, org_list: {type:'group' ,list:org_item}})
                API.get_create_campaign_info({org_id: org_id, campaign_id: campaign_id}).then(res=>{
                    let result = res.data
                    this.tf_start.start_date = this.getMsgTime()
                    this.tf_start.start_time = '00:00:00'
                    this.supply_source = result.supply_source
                    this.daily_budget_currency = result.config.currency
                    this.daily_budget = result.daily_budget
                    // this.daily_budget = result.config.default_bid_amount
                    this.cpa_goal = result.config.cpa_goal
                    this.big_daily_budget = result.config['default_bid_amount']

                    this.countries_or_regions = result['countries_or_regions']
                    this.countries_or_regions_support_target = result['countries_or_regions_support_target']
                    this.form.time_zone = result.config['time_zone']
                    this.prev_start_time = result['start_time'] ? result['start_time'] : ''
                    this.prev_end_time = result['end_time'] ? result['end_time'] : ''
                    this.app_downloader_list = result['app_downloader_select_list'] ? result['app_downloader_select_list'].map(item=>{
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }) : []
                    this.sz_Form.app_downloader = this.app_downloader_list.length != 0 ? this.app_downloader_list[0]['value'] : ''
                    return result.adam_id
                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                }).then((adam_id)=>{
                    this.get_app_eligibility(adam_id, org_id).then(()=>{
                        this.editLoading = false
                    })
                })
            },
            get_app_eligibility(adam_id, org_id) {
                return API.get_create_app_eligibility({adam_id:adam_id, org_id: org_id}).then(res=>{
                    let result = res.data
                    let min_age = result[this.supply_source]['min_age']

                    let result_device_class = result[this.supply_source]['device_class']
                    let reres_device_list = []
                    let res_device = result_device_class ? Object.keys(result_device_class) : []
                    res_device.forEach(item=>{
                        reres_device_list.push({
                            value: item,
                            label: result_device_class[item]
                        })
                    })
                    this.device_class_list = reres_device_list
                    this.device_class = reres_device_list.map(item=>item.value)
                    
                    const res_startYear = Array.from({ length: 47 }, (_, index) => index + Number(min_age));
                    const res_endYear = Array.from({ length: 46 }, (_, index) => index + 19);
                    this.startYear = res_startYear
                    this.endYear = res_endYear


                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 广告组名称 change 事件
            handleAdName(event) {
                let result_value = event.target.value
                if(this.adname_mul) return
                this.validateItem('adgroup_name', result_value, 
                    [
                        { required: true, message: '必填项不可为空'},
                        {  max: 200, message: '长度最多200个字符'},
                        { reg: true,  message: '不可输入[]\;{}"<>与表情'}
                    ]
                );
                // setTimeout(() => {
                //     if(this.errorsMsg['adgroup_name'] == '') {
                //         if(result_value != '') {
                //             this.adname_some(result_value)
                //         }
                //     }
                // }, 100);
            },
            handleAdNameInput:throttle(function(value) {
                // 在这里执行你的输入处理逻辑
                console.log('Input value:', value);
                this.adname_some(this.form.adgroup_name)
            }, 2200),
            // 校验广告组名称是否为空
            adname_some(adgroup_name) {
                return API.getPromotionAdgroupName({
                    campaign_id:this.form.campaign_id,
                    adgroup_name:adgroup_name,
                    adgroup_id:this.adgroup_id ? this.adgroup_id : ''
                }).then(res=>{
                    console.log('res', res)
                    this.adname_mul = false
                    return false
                },err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.adname_mul = true
                    this.errorsMsg['adgroup_name'] = err.info
                    return true
                    // 同一广告系列内广告组名称不可重复
                    // this.$message.error(err.info||'请求失败');
                })
            },
            // 投放日期tab切换
            handletfdate(value) {
                if(value == '1') {
                    this.form.end_time = ''
                    this.tf_end.start_date = ''
                    this.tf_end.start_time = ''
                    this.errorsMsg['tf_time_2'] = ''
                }
            },
            changeTimeZone(value) {
                this.form.time_zone = value
            },
            // 出价处理
            handleInput(val, name, limit = 2) {
                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                if(this.daily_budget_currency=='美元'&&name=='default_bid_amount'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='adgroup'&&item.field=='default_bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||2;
                }

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                this.form[name] = rval
            },
            // 关键词
            showKeywordModal(){
                this.$refs.keywordModal.showModal();
            },
            // 否定关键词
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            clearKeyword(){
                this.keyword = [];
            },
            clearNegativeKeyword(){
                this.negative_keyword = [];
            },
            // 选择我其他的app
            handleSelectOutApp() {
                let params = this.sz_Form.app_downloader_apps && this.sz_Form.app_downloader_apps.length == 0 ? [] : this.sz_Form.app_downloader_apps
                this.$refs.appModal.showModal(params, this.form.org_id)
            },
            // 投放日期选择
            handleDateState(value) {
                console.log(value)
                // this.tf_start.start_date = value
            },
            handleDateEnd(value) {
                console.log(value)
                // this.tf_end.start_date = value
            },
            // 投放时间选择
            handleTime(value) {
                console.log(value)
            },
            concat_start_date() {
                if(this.tf_start['start_date'] && this.tf_start['start_time']) {
                    this.form.start_time = `${this.tf_start['start_date']} ${this.tf_start['start_time']}`
                }else{
                    this.form.start_time = ''
                }
            },
            concat_end_date() {
                if(this.tf_end['start_date'] && this.tf_end['start_time']) {
                    this.form.end_time = `${this.tf_end['start_date']} ${this.tf_end['start_time']}`
                }else{
                    this.form.end_time = ''
                }
            },
            // 子组件吐出 时间段
            getdaypart(params) {
                this.form.daypart = params
            },
            // 默认最高每次点击出价
            handleamount(value) {
                // 走个请求
                if(value != '') {
                    API.get_create_app_am_config({org_id: this.form.org_id}).then(res=>{
                        let result = res.data
                        this.avg_default_bid_amount = result.avg_default_bid_amount
                    }, err=>{
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                    this.clearValidateItem('default_bid_amount')
                }
            },
            // 显示关键词
            showKeywordModal(){
                this.$refs.keywordModal.showModal();
            },
            saveKeyword(list){
                this.keyword = [...list];
            },
            // 显示否定关键词
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            saveNegativeKeyword(list){
                this.negative_keyword = [...list];
            },
            // 子组件吐出 选择app
            getOutApp(params) {
                this.sz_Form.app_downloader_apps = params
            },
            // 用户类型选择
            // 年龄 开始change
            handleAgeStart(value) {
                let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                if(Number(aend) < Number(this.ageForm.start)) {
                    this.errorsMsg['ageForm_start'] = '最小年龄需小于最大年龄'
                }else{
                    this.errorsMsg['ageForm_start'] = ''
                }
            },

            // 年龄 结束change
            handleAgeEnd(value) {
                let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                if(Number(aend) < Number(this.ageForm.start)) {
                    this.errorsMsg['ageForm_start'] = '最小年龄需小于最大年龄'
                }else{
                    this.errorsMsg['ageForm_start'] = ''
                }
            },
            // 国家 省 自治区
            remoteMethodCity(query, type) {
                if (query == '' || query.length == 1) {
                    this.countryOptions = []
                    this.areaOptions = []
                    this.localityOptions = []
                    return
                }
                let nums =  Object.keys(this.countries_or_regions) 
                let country_code = ''
                if(nums.length == 1) {
                    country_code = nums[0]
                }
                if(type == 'country') {
                    // 获取国家下拉框
                    this.searchCountryLoading = true
                    API.getPromotionCountryOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchCountryLoading = false
                        let reslute = res.data
                        this.countryOptions = reslute
                    }, err=>{
                        this.searchCountryLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }else if(type=='admin_area') {
                    // 获取省
                    this.searchAdminLoading = true
                    API.getPromotionAreaOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchAdminLoading = false
                        let reslute = res.data
                        this.areaOptions = reslute
                    }, err=>{
                        this.searchAdminLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }else if(type=='locality') {
                    // 获取城市
                    this.searchLocalityLoading = true
                    API.getPromotionLocalityOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchLocalityLoading = false
                        let reslute = res.data
                        this.localityOptions = reslute
                    }, err=>{
                        this.searchLocalityLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }
            },
            handleallchange(value, name) {
                if(value) {
                    this.clearValidateItem(name)
                }
            },
            valisubmitPromise() {
                const valiPro = new Promise((resolve, reject) => {
                    // let ispull = false
                    if(this.form.org_id == '') {
                        this.errorsMsg.org_id = this.errTips
                        reject()
                        return
                    }
                    if(this.form.campaign_id == '') {
                        this.errorsMsg.campaign_id = this.errTips
                        reject()
                        return
                    }
                    if(this.form.adgroup_name == '') {
                        this.errorsMsg.adgroup_name = this.errTips
                        reject()
                    }
                    if(this.adname_mul) {
                        this.errorsMsg.adgroup_name = '同一广告系列内广告组名称不可重复'
                        reject()
                    }
                    if(this.tfdate == '1') {
                        if(this.form.start_time == '') {
                            this.errorsMsg.tf_time = this.errTips
                            reject()
                        }else{
                            let prev_endtime = this.prev_end_time ? new Date(this.prev_end_time).valueOf() : 0
                            let startTims = new Date(this.form.start_time).valueOf()
                            console.log('prev_endtime', prev_endtime, startTims > prev_endtime)
                            if(prev_endtime != 0 && startTims > prev_endtime) {
                                this.errorsMsg.tf_time = '开始日期与时间不可大于上级广告系列的结束日期与时间'
                                reject()
                            }
                        }
                    }


                    if(this.tfdate == '2') {
                        if(this.form.end_time == '') {
                            this.errorsMsg.tf_time_2 = this.errTips
                            reject()
                        }else{
                            let prev_starttime = this.prev_start_time ? new Date(this.prev_start_time).valueOf() : 0

                            let result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                            let result_end = this.form.end_time ? new Date(this.form.end_time).valueOf() : 0

                            if(result_start != 0 && result_end != 0) {
                                if(result_start >= result_end) {
                                    this.errorsMsg.tf_time = '结束日期不可早于开始日期与时间'
                                    reject()
                                }else if(prev_starttime != 0 && prev_starttime > result_end) {
                                    this.errorsMsg.tf_time =  '结束日期与时间不可小于上级广告系列的开始日期与时间'
                                    reject()
                                }
                            }
                        }
                    
                    }
                    if(this.tftime == '2' && this.supply_source == 'APPSTORE_SEARCH_RESULTS' && this.form.daypart.length == 0) {
                        this.errorsMsg.daypart = this.errTips
                        reject()
                    }
                    if(this.form.default_bid_amount == '') {
                        this.errorsMsg.default_bid_amount = this.errTips
                        reject()
                    }

                    if(Number(this.daily_budget) != 0 && Number(this.daily_budget) < Number(this.form.default_bid_amount)) {
                        this.errorsMsg.default_bid_amount = '不可大于上级广告系列的预算，请重新输入'
                        reject()
                    }

                    if(Number(this.big_daily_budget)  < Number(this.form.default_bid_amount)){
                        reject()
                        this.errorsMsg.default_bid_amount = '不可大于默认最高出价，请重新输入'
                    }


                    if(this.targeting_type == '2') {
                        let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2

                        if(this.device_class == '') {
                            this.errorsMsg.device_class = this.errTips
                            reject()
                        }
                        if(this.sz_Form.app_downloader == '') {
                            this.errorsMsg.app_downloader = this.errTips
                            reject()
                        }
                        if(this.sz_Form.app_downloader == '4' && this.sz_Form.app_downloader_apps.length == 0 ) {
                            this.errorsMsg.outApp = this.errTips
                            reject()
                        }
                        if(this.age_type == '2') {
                            if(this.ageForm.start == '') {
                                this.errorsMsg.ageForm_start = this.errTips
                                reject()
                            }
                            if(this.ageForm.end == '') {
                                this.errorsMsg.ageForm_end = this.errTips
                                reject()
                            }
                            let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                            if(Number(aend) < Number(this.ageForm.start)) {
                                this.errorsMsg['ageForm_start'] = '最小年龄需小于最大年龄'
                                reject()
                            }
                        }
                        if(this.positioning_type == '2' && nums == 1 && this.countries_or_regions_support_target) {
                            if(this.positioningForm.country.length == 0 && this.positioningForm.admin_area.length == 0 && this.positioningForm.locality.length == 0) {
                                this.errorsMsg.country = this.errTips
                                reject()
                            }
                        }
                    }
                    resolve(true)
                })
                return valiPro
                // return ispull
            },
            handleSubmit(name, type) {
                this.valisubmitPromise().then(res=>{
                    this.adname_some(this.form.adgroup_name).then((adRes)=>{
                        if(adRes) {
                            this.$message.error('表单数据填写有误，请检查后重新提交');
                        }else{
                            this.tofecth(name, type)
                        }
                    })
                }).catch(()=>{
                    this.$message.error('表单数据填写有误，请检查后重新提交');
                })

            },
            tofecth(name, type) {
                let params = {}
                if(this.supply_source == 'APPSTORE_SEARCH_RESULTS') {
                    params['cpa_goal'] = this.form.cpa_goal
                    
                }
                
                if(this.tfdate == '2') {
                    params['end_time'] = this.form.end_time
                }
                if(this.tftime == '2') {
                    params['daypart'] = this.form.daypart
                }
                if(this.targeting_type == '2') {
                    let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2

                    params['device_class'] = this.device_class
                    params['app_downloader'] = this.sz_Form.app_downloader

                    if(this.sz_Form.app_downloader == '4') {
                        params['app_downloader_apps'] = this.sz_Form.app_downloader_apps.map(item=>item.adam_id)
                    }
                    if(this.age_type == '2') {
                        let age = []
                        if(this.ageForm.end == '65') {
                            age = [this.ageForm.start]
                        }else{
                            age = [this.ageForm.start, this.ageForm.end]
                        }
                        params['age'] = age
                    }
                    
                    if(this.positioning_type == '2' && nums == 1 && this.countries_or_regions_support_target) {
                        params['country'] = this.positioningForm.country 
                    }
                    if(this.positioning_type == '2'  && nums == 1 && this.countries_or_regions_support_target) {
                        params['admin_area'] = this.positioningForm.admin_area 
                    }
                    if(this.positioning_type == '2'  && nums == 1 && this.countries_or_regions_support_target) {
                        params['locality'] = this.positioningForm.locality 
                    }
                }
                if(this.supply_source == 'APPSTORE_PRODUCT_PAGES_BROWSE') {
                    params['app_categories'] = this.form.app_categories
                }
                if(this.supply_source == 'APPSTORE_SEARCH_RESULTS') {
                    params['automated_keywords_opt_in'] = this.form.automated_keywords_opt_in
                }
                if(this.apple_create_type != 'editGroup' && this.negative_keyword.length != 0) {
                    let res_negativeKeyword = this.negative_keyword.map(item=>{
                        return {
                            text:item.key_word_text,
                            match_type:item.match_type=='精准匹配'?'EXACT':(item.match_type=='广泛匹配'?'BROAD':''),
                        }
                    });
                    params['negative_keyword'] = JSON.stringify(res_negativeKeyword);
                }

                if(this.apple_create_type != 'editGroup' && this.keyword.length != 0) {
                    let res_keyword = this.keyword.map(item=>{
                        return {
                            text:item.key_word_text,
                            bid_amount:item.bid_amount,
                            match_type:item.match_type=='精准匹配'?'EXACT':(item.match_type=='广泛匹配'?'BROAD':''),
                        }
                    });
                    params['keyword'] = JSON.stringify(res_keyword);
                }

                params['time_zone'] = this.form.time_zone
                params['default_bid_amount'] = this.form.default_bid_amount
                params['org_id'] = this.form.org_id
                params['campaign_id'] = this.form.campaign_id
                params['adgroup_name'] = this.form.adgroup_name
                params['start_time'] = this.form.start_time
                params['gender'] = this.sz_Form.gender
                console.log('保存结果', params)


                
                
                let currency_time = new Date().valueOf()
                let current_name = `ads_${currency_time}`
                
                if(this.apple_create_type == 'editGroup') {
                    this.dialogVisible = true
                    this.dialogTypeTitle= '编辑广告组，正在处理…'
                    let editInfo = this.$store.getters.apple_edit_info
                    params['adgroup_id'] = editInfo['adgroup_id']
                    API['adgroup_edit_adgroup'](params,{
                        timeout: 120*1000,
                    }).then(res=>{
                        let resultData = res.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''

                        // 单个请求成功
                        let flag_single_post_html = get_flag_suc_html(res['info'], '')
                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: flag_single_post_html
                        });
                        // this.$emit('postresult', {loading: false, dialog: false, success: true, type:type,org_list: {type:'group' ,list:[]}})
                        this.$emit('postresult', {loading: false, dialog: false, success: true, type:type, org_list: {type:'group' ,list:[]}})
                    }, err=>{
                        let resultData = err.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''
                        if(err.code =='403'){
                            this.$confirm(err.info, '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {});
                                return          
                        }
                        // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                        let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'],[],[],current_name );

                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: flag_mul_err_html
                        });
                        this.$store.commit('apple/ADD_NOTIFY', {
                            id: `${current_name}_close`,
                            value: current_tip,
                        });
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, type:type, org_list: {type:'group' ,list:org_item}})
                        
                    })
                }else{
                    this.dialogVisible = true
                    this.dialogTypeTitle= '创建广告组，正在处理…'

                    API[name](params,{
                        timeout: 120*1000,
                    }).then(res=>{
                        let resultData = res.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''

                        // 单个请求成功
                        let flag_single_post_html = get_flag_suc_html(res['info'], '')
                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: flag_single_post_html
                        });

                        this.$emit('postresult', {loading: false, dialog: false, success: true, type:type,org_list: {type:'group' ,list:[]}})
                    }, err=>{
                        let resultData = err.data||{};
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle = ''
                        if (err.code == '403') {
                            this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }

                        let campData = resultData.data||{};
                        let isCreateCampSuccess = campData.campaign_id&&campData.campaign_name;

                        let keywordErrList = resultData.keyword_err_list||[];
                        let negativeKeywordErrList = resultData.negative_keyword_err_list||[];


                        // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                        let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'], keywordErrList, negativeKeywordErrList,current_name );

                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: flag_mul_err_html
                        });
                        this.$store.commit('apple/ADD_NOTIFY', {
                            id: `${current_name}_close`,
                            value: current_tip,
                        });
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, type:type, org_list: {type:'group' ,list:org_item}})
                    })
                }
            }
        }

    }
    
</script>
<style lang="scss" scoped>
.apple_group{
    .create_list{
        background-color: #fff;
        padding: 10px;
        margin-bottom: 20px;
        .create_title{
            font-size: 14px;
            padding-bottom: 10px;
            padding-left: 20px;
        }
        .create_item{
            display: flex;
            align-items: center;
            padding-bottom: 30px;
            .create_label{
                flex: 0 0 220px; 
                text-align: left;
                .star{
                    color: #ff0000;
                    font-size: 16px;
                    display: inline-block;
                    vertical-align: middle;
                    padding-right: 4px;
                    padding-left: 20px;
                }
                .create_label_text{
                    font-size: 12px;
                    display: inline-block;
                    color: #606266;
                    
                }
            }
            .create_action{
                flex: 0 0 450px; 
                position: relative;
                .create_err_bottom{
                    color: #ff0000;
                    position: absolute;
                }
                .posi{
                    position: absolute;
                }
            }
            .create_err_right{
                flex: auto; 
                display: inline-block;
                color: #ff0000;
            }
            .questions {
                width: 12px;
                height: 12px;
                line-height: 14px;
                text-align: center;
                border-radius: 10px;
                background-color: #333;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                margin-left: 2px;
                cursor: pointer;
            }
            .ad_name_flex{
                display: flex;
                align-items:center;
                .num_length{
                    padding-left:10px;
                    font-size: 12px;
                    color: #606266;
                    flex: 0 0 60px;
                }
            }
        }
    }
    .create_divider{
        background-color:#fff;
        border-bottom: 1px solid #d9d9d9;
        padding: 12px 10px;
    }
}
</style>
